import React from 'react'

type LabelProps = React.ComponentPropsWithoutRef<'label'> & {
    size?: 'lg' | 'md' | 'sm' | 'xs'
    intent?: 'default' | 'danger'
}

const Label = React.forwardRef<HTMLSpanElement, LabelProps>(
    ({ children, className, size = 'md', intent = 'default', ...props }, ref) => {
        const sizeClasses = {
            lg: 'text-label-lg',
            md: 'text-label-md',
            sm: 'text-label-sm',
            xs: 'text-label-xs',
        }

        const intentClasses = {
            default: 'font-bold',
            danger: 'text-danger-400',
        }

        return (
            <span
                {...props}
                ref={ref}
                className={`${intentClasses[intent]} ${sizeClasses[size]} ${className}`}
            >
                {children}
            </span>
        )
    }
)

Label.displayName = 'Label'

export default Label
